import { render, staticRenderFns } from "./ArchivedCategoriesAndActivities.vue?vue&type=template&id=2f84332e&scoped=true&"
import script from "./ArchivedCategoriesAndActivities.vue?vue&type=script&lang=js&"
export * from "./ArchivedCategoriesAndActivities.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCategoriesAndActivities.vue?vue&type=style&index=0&id=2f84332e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84332e",
  null
  
)

export default component.exports